import { useIntl } from 'react-intl';
import React, { useState } from 'react';
import CustomModal from 'src/components/customModal/customModal';
import { APP_META } from 'src/services/config';
import { WalletSelectorFooter } from 'src/context/modal-ui/components/WalletOptions/WalletOptions';

const WalletRiskCheckBox = (props: any) => {
  const { setCheckedStatus } = props;
  const intl = useIntl();
  const login_tip = intl.formatMessage(
    { id: 'login_risk_tip' },
    { appName: APP_META.name }
  );
  const [checkBoxStatus, setCheckBoxStatus] = useState(false);

  function onAcknowledgeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const newStatus = event.target.checked;
    setCheckBoxStatus(newStatus);
    setCheckedStatus(newStatus);
  }

  return (
    <label
      className={`flex items-start cursor-pointer ${
        checkBoxStatus ? 'my-4' : 'mb-4 mt-1'
      }`}
    >
      <input
        type="checkbox"
        checked={checkBoxStatus}
        onChange={onAcknowledgeChange}
        className="mt-0.5 mr-3 flex-shrink-0 cursor-pointer accent-[#00C6A2] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#00C6A2] focus-visible:ring-offset-2 focus-visible:ring-offset-[#1D2932]"
        style={{ width: 20, height: 20, minWidth: 20 }}
      />
      <span className="text-sm text-v3SwapGray">{login_tip}</span>
    </label>
  );
};

interface ModalProps {
  isOpen: boolean;
  setCheckedStatus: any;
  onClose: any;
}

export const WalletRiskCheckBoxModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  setCheckedStatus,
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      onOutsideClick={onClose}
      className={'modal-style1x'}
      title={'Connect Wallet'}
      width={470}
    >
      <WalletRiskCheckBox setCheckedStatus={setCheckedStatus} />
      <WalletSelectorFooter />
    </CustomModal>
  );
};
